import React from 'react'

import { string } from 'prop-types'

import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import i18n from 'Pods/Shared/I18n'
import { setSubscriptionEntry } from 'Pods/Shared/Utils/subscriptionEntry'

const SUBSCRIPTION_PATH = '/subscription'

function GetSubscriptionChip({ locale = 'en' }) {
  const handleClick = () => {
    setSubscriptionEntry(SubscriptionEntryPoints.NAV_HEADER_CHIP)
  }

  return (
    <a
      href={SUBSCRIPTION_PATH}
      className="cgt-button-text-base-semibold unified-nav__get-subscription"
      onClick={handleClick}
      data-subscription-entry={SubscriptionEntryPoints.NAV_HEADER_CHIP}
    >
      {i18n.t('navigation.get_subscription', { ns: 'rails', lng: locale })}
    </a>
  )
}

GetSubscriptionChip.propTypes = {
  locale: string,
}

export default GetSubscriptionChip
